import './SidebarMenus.scss';

import { observer } from 'mobx-react';
import React from 'react';

import * as api from '../../../stores/api';
import dashboard from '../../../stores/dashboard';
import router from '../../../stores/router';
import customFetch from '../../../utils/customFetch';
// import Tooltip from '../../shared/Tooltip';
import { MenuGroup, MenuItem } from './Menu';

@observer
class SidebarMenus extends React.Component {
  showConfirm = e => {
    e.preventDefault();
    const r = window.confirm(
      'Requesting Non-MAG Supplementary Reports refer to cases where original assessments were not handled by MAG. If this is not the case, place a request from the original case within either IME Services or File Reviews. Do you want to proceed with Non-MAG case request?',
    );

    if (r === false) {
      return false;
    }
    router.history.push('/view/new-supplementary-report');
  };

  functionalCapacityAssessmentsClick = e => {
    e.preventDefault();
    return false;
  };

  showConfirmRequestRefund = e => {
    e.preventDefault();
    const r = window.confirm(
      'Do you want to request Disbursement Funding for your account?',
    );

    if (r === false) {
      return false;
    }

    customFetch('/Staff/RequestDisbursementFunding', {
      method: 'POST',
    }).then(data => {
      if (data.status === 'success') {
        alert(
          'Your Disbursement Funding request has been received and you will be contacted within 24 hours.',
        );
      } else {
        alert('Request Disbursement Fail.');
      }
    });
    dashboard.open('/view/dashboard');
  };

  handleRevokeImpersonation = () => {
    customFetch('/account/RevertImpersonation', {
      method: 'POST',
    }).then(() => {
      var url =
        window.location.protocol +
        '//' +
        window.location.host +
        '/view/dashboard';
      window.location = url;
    });
  };

  renderDoctorMenu = () => (
    <React.Fragment>
      <MenuItem path="/view/universal-search" title="FIND MY CASES" materialIcon />
      <MenuItem path="/view/calendar-2" title="MY CLINIC CALENDAR" materialIcon/>
      <MenuGroup title="My Cases" name="service-center" materialIcon>
        <MenuItem path="/view/doctor-ime" noImage/>
        <MenuItem path="/view/doctor-file-reviews" title="File Reviews (F)" noImage/>
        <MenuItem
          path="/view/doctor-supplementary"
          title="Supplementary Reports (S)"
          noImage
        />
      </MenuGroup>
      {window.__newui.enable && <MenuItem path="/view/appointments" title="APPOINTMENTS" materialIcon />}
      <MenuItem path="/view/send-feedback-2" title="SEND FEEDBACK" materialIcon/>
    </React.Fragment>
  );

  renderAdminMenu = () => (
    <React.Fragment>
      {api.isAdminOrMagStaffOrAccounting() && <MenuItem path="/view/admin-account-2" title="MY DETAILS" materialIcon/>}
      <MenuItem path="/view/calendar-2" title="CLINIC CALENDAR" materialIcon/>
      <MenuGroup title="SEARCH OPTIONS" hidden name="search" materialIcon>
        <MenuItem path="/view/universal-search" title="Search All Cases" noImage/>
        <MenuItem path="/view/docs-search" title="Search Texts in Case Documents (beta)" noImage />
        <MenuItem path="/view/action-required-search" title="Search Actions & Tasks Due" noImage />
        <MenuItem path="/view/smart-search" title="Search Appointment Sessions" noImage />
      </MenuGroup>
      <MenuGroup title="USER ACCOUNTS" hidden name="account-center" materialIcon>
        <MenuItem path="/view/clients-2" noImage/>
        <MenuItem path="/view/case-managers-2" noImage/>
        <MenuItem path="/view/typist" noImage/>
        <MenuItem path="/view/specialists-2" noImage/>
        <MenuItem path="/view/medical-centres-2" noImage/>
        <MenuItem path="/view/claimants-2" noImage/>
        <MenuItem path="/view/login-users-2" noImage/>
      </MenuGroup>
      <MenuGroup title="SERVICE CENTRE" name="service-center" materialIcon>
        <MenuItem path="/view/ime-assessments-2" title="IME Assessments (A)" noImage/>
        <MenuItem path="/view/admin-file-reviews" title="File Reviews (F)" noImage/>
        <MenuItem path="/view/supplementary-reports-2" title="Supplementary Reports (S)" noImage />
        <MenuItem title="Medical Negligence (MN)" path="/view/admin-med-neg" noImage/>
        <MenuItem path="https://video.medicolegalexpress.com.au" target="_blank" noImage/>
      </MenuGroup>
      {/* <MenuGroup title="INVOICES & BILLINGS" hidden>
        <MenuItem
          path="/view/invoices-2"
          title="Client Invoicing & Doctor Billing"
        />
      </MenuGroup>
     */}
      <MenuItem
        path="/view/invoices-2"
        title="BILLING"
        materialIcon
      />
      <MenuGroup title="REPORT CENTRE" materialIcon name={'report-centre'} hidden >
        <MenuItem title="Client Reports" path="/view/client-reports-2" noImage/>
        <MenuItem title="Case Manager Reports" path="/view/cm-reports" noImage/>
        <MenuItem title="Specialist Reports" path="/view/doctor-reports-2" noImage/>
        <MenuItem title="Marketing Campaigns (beta)" path="/view/marketing-campaign" noImage />
        <MenuItem title="Login History" path="/view/login-history-2" noImage/>
      </MenuGroup>

      <MenuGroup title="VALUE SETTINGS" hidden name="value-settings" materialIcon>
        <MenuItem path="/view/job-title-2" noImage/>
        <MenuItem path="/view/manage-spe-acc" noImage/>
        <MenuItem path="/view/types-of-claims-2" noImage/>
        <MenuItem path="/view/types-of-report-2" noImage/>
        <MenuItem path="/view/industry-segments-2" noImage/>
        <MenuItem path="/view/ims-approval-2" noImage/>
        <MenuItem path="/view/service-fee-2" noImage/>
        {api.isMAG() && <MenuItem path="/view/ama-service-fee" noImage/>}
        <MenuItem path="/view/module-type-template" noImage/>
        <MenuItem path="/view/message-template" title="Mail Templates" noImage/>
        <MenuItem path="/view/sale-target" noImage/>
        {api.isAdmin() && (
          <React.Fragment>
            <MenuItem path="/hangfire" target="_blank" noImage/>
            <MenuItem
              path="/view/system-config"
              title="System Configurations" noImage
            />
          </React.Fragment>
        )}
      </MenuGroup>
      {api.isAdminOrMagStaffOrAccounting() && <MenuItem path="/view/notification" title="NOTIFICATIONS" materialIcon/>}
      {api.isMagStaff() && <MenuItem path="/view/send-feedback-2" title="SEND FEEDBACK" materialIcon/>}
    </React.Fragment>
  );

  renderMenu = clientType => (
    <React.Fragment>
      {(api.isTypist()) && <MenuItem path="/view/tp-detail" title="MY DETAILS" materialIcon/>}
      {!api.isTypist() && <MenuItem path="/view/calendar-2" title="CLINIC CALENDAR" materialIcon />}
      <MenuGroup title="SEARCH OPTIONS" hidden name="search" materialIcon>
        <MenuItem path="/view/universal-search" title="Search All Cases" noImage />
        {!api.isTypist() && (
          <MenuItem path="/view/smart-search" name="search" title="Search Appointment Sessions" noImage />
        )}
      </MenuGroup>
      <MenuGroup title="My Cases" name="service-center" materialIcon>
        <MenuItem title="IME Reports (A)" path="/view/ime-assessments-2" noImage/>
        {/* {!api.isTypist() && (
          <Tooltip appear="Contact us for more information regarding this service.">
            <div>
              <MenuItem
                labelMenu="labelMenu"
                path="/FunctionalCapacityAssessments"
                onClick={this.functionalCapacityAssessmentsClick}
                title="Functional Capacity Assessments"
              />
            </div>
          </Tooltip>
        )} */}
        <MenuItem title="File Reviews (F)" path="/view/admin-file-reviews" noImage/>
        <MenuItem
          title="Supplementary Reports (S)"
          path="/view/supplementary-reports-2" noImage
        />
      </MenuGroup>
      {!api.isTypist() && <MenuItem path="/view/send-feedback-2" title="SEND FEEDBACK" materialIcon/>}
    </React.Fragment>
  );

  render() {
    const { ClientType } = api.currentUser.data;
    return (
      <div className="SidebarMenus">
        <MenuItem path="/view/dashboard" title="HOME" materialIcon />
        {!api.isAdminOrMagStaffOrAccounting() && !api.isTypist() && (
          <MenuItem
            path={api.isDoctor() ? '/view/dr-account-2' : '/view/cm-account-2'}
            title="MY DETAILS" 
            materialIcon
          />
        )}
        {api.isDoctor()
          ? this.renderDoctorMenu()
          : api.isAdminOrMagStaffOrAccounting()
            ? this.renderAdminMenu()
            : this.renderMenu(ClientType)}

        <MenuItem path="/view/logout" title="LOGOUT" materialIcon/>
        {api.isImpersonated() && (
          <MenuItem path="/account/RevertImpersonation" title="REVOKE" onClick={this.handleRevokeImpersonation} materialIcon/>
        )}
      </div>
    );
  }
}

export default SidebarMenus;
